/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompleteStorefrontLoginRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {CompleteStorefrontLoginResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const completeStorefrontLogin = (request: CompleteStorefrontLoginRequest, options?: CashRequestOptions) => post<CompleteStorefrontLoginRequest, CompleteStorefrontLoginResponse>("/cash-app/local/complete-storefront-login", request, {...options, rejectOnError: true })